/**
 * Currency Configuration
 * 
 * النظام يستخدم عملة ثابتة: الدينار العراقي
 * لتغيير العملة، عدّل هذا الملف فقط
 * 
 * @example
 * import { CURRENCY } from '@/constants/currency';
 * console.log(CURRENCY.symbol); // 'د.ع'
 */

export const CURRENCY = {
  /** رمز العملة ISO 4217 */
  code: 'IQD',
  
  /** الاسم بالعربية */
  nameAr: 'دينار عراقي',
  
  /** الاسم بالإنجليزية */
  nameEn: 'Iraqi Dinar',
  
  /** رمز العملة للعرض */
  symbol: 'د.ع',
  
  /** عدد الأرقام العشرية */
  decimals: 0,
} as const;

/** نوع العملة */
export type Currency = typeof CURRENCY;

/**
 * تنسيق المبلغ مع رمز العملة
 * @param amount - المبلغ
 * @returns المبلغ منسق مع رمز العملة
 */
export function formatWithCurrency(amount: number): string {
  const formatted = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: CURRENCY.decimals,
    maximumFractionDigits: CURRENCY.decimals,
  }).format(amount);
  
  return `${formatted} ${CURRENCY.symbol}`;
}
